import { useNavigate } from 'react-router-dom'
import handleNavigation from './handleNavigate'
import { SelectedRFPContext } from '../Contexts/SelectedRFPContext'
import { UserContext } from '../Contexts/UserContext'
import { useContext, useEffect, useState } from 'react'
import './ListofRFPs.css'
import { Modal } from '@nxtvid/component-library'


const ListOfRFPs = ({RFPList, setRFPs, RFPs}) =>{
    
    const navigate = useNavigate()
    const settings_icon = require('../Images/settings-icon.png')
    const edit_icon = require('../Images/edit-icon.png')
    const {setSelectedRFP} = useContext(SelectedRFPContext)
    const {userInfo} = useContext(UserContext)
    
    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalType, setModalType] = useState('confirm')
    const [modalSize, setModalSize] = useState('medium')
    const [modalTitle, setModalTitle] = useState('')
    const [modalDescription, setModalDescription] = useState('' )
    const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
    const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
    const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
    const [modalCancelButtonText, setModalCancelButtonText] = useState('')
    //useEffect to get all RFPs from /api/rfp/getAllRFPs endpoint. This should be run for each RFP within userInfo._RFPs array
    console.log(userInfo)  
    useEffect(() => {
        if (userInfo.RFPs) {
          const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
          const uniqueRFPs = [...new Set(userInfo.RFPs)]; // Ensure unique RFPs
            console.log(uniqueRFPs)
            const fetchRFPs = async () => {
                try {
                    const response = await fetch(`${API_BASE_URL}/api/rfp/getAllRFPs`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
                        },
                        body: JSON.stringify({ userId: userInfo._id }),
                    });
                    const result = await response.json();
                    console.log(result.rfps)
                    setRFPs(result.rfps);
                } catch (error) {
                    console.error('Error fetching RFPs:', error);
                }
            }
            fetchRFPs();
        }
      }
    , [userInfo]);
    
    const handleDeleteRFP = (selectedRFP) =>{
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
        const deleteRFP = async (selectedRFP) => {
            try{
                const response = await fetch(`${API_BASE_URL}/api/rfp/deleteRFP`, {
                    method:'POST',
                    headers:{
                        'Content-Type': 'application/json',
                        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
                    },
                    body:JSON.stringify({ userId: userInfo._id, _id : selectedRFP }),
                });
                const result = await response.json();
                setRFPs(prevRFPs => prevRFPs.filter(RFP => RFP._id !== selectedRFP))
                console.log(result)
            } catch(error){
                console.error('Error: ', error)
            }
        }
        deleteRFP(selectedRFP)
        
    }

    RFPList = RFPs.map(RFP =>{
            return(
            <div className="RFPCard">
                <div className="RFPCard-content">
                    <div className="RFP-name-container">
                        <p className="RFPCard-name">{RFP.title}</p>
                        <div className="settings-container">
                        <img alt="settings icon" className="settings-icon" src={settings_icon}/>
                        <div className="RFP-settings">
                            <p className="RFP-setting" onClick={()=>{setModalOnConfirm(()=>()=>{handleDeleteRFP(RFP._id); setIsModalOpen(false)});setModalTitle('Delete RFP') ; setModalDescription('Are you sure you want to delete this RFP? This action is irreversable.'); setIsModalOpen(true); setModalCancelButtonText('Cancel'); setModalConfirmButtonText('Delete RFP'); setModalOnCancel(()=>()=>setIsModalOpen(false))}}>Delete RFP</p>
                        </div>
                        </div>
                    </div>
                    <div className="RFPCard-details">
                    <p className="RFPCard-detail">Budget: {RFP.budget}</p>
                    <p className="RFPCard-detail">Deadline: {RFP.proposalSubmissionDeadline}</p>
                    <div className="RFPCard-detail">
                        <p className="edit-RFP-label" onClick={()=>{setSelectedRFP(RFP._id); handleNavigation({path:"/RFPBuilder", navigate})}}>Edit RFP</p>
                        <img onClick={()=>{setSelectedRFP(RFP._id); handleNavigation({path:"/RFPBuilder", navigate})}} className='edit-icon' src={edit_icon} alt="edit icon"/>
                    </div> 
                    </div>
                    
                </div>                
            </div>
            )           
    })
    return (
        <div className="RFPList">
        {isModalOpen ? <Modal type={modalType} onConfirm={()=>modalOnConfirm()} onClose={()=>modalOnCancel()} size={modalSize} title={modalTitle} description={modalDescription} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : null}
        {RFPList}
        </div>)
}

export default ListOfRFPs